module.exports = __webpack_public_path__ + "static/media/mob_time@2x.0ceda669.png";